
<style scoped>
    form {
        overflow: hidden;
    }
    .Nav {
        margin-bottom: 0.5rem;
    }
    .Nav span {
        padding: 0.5rem;
    }

    button {
        min-width: 120px;
        min-height: 34px;
    }

    .Dev {
        opacity: 0.5;
        font-size: 0.7rem;
    }
    .DevButton {
        min-width: 60px;
        width: 60px;
        max-width: 60px;
        margin-left: 12px;
    }

    .BackButton {
        max-width: 25%;
        margin-left: 12px;
    }

    fieldset.Fieldset {
        border-style: solid;
        border-width: 2px;
        /* border-color: rgba(164, 164, 164, 1); */
        border-color: rgb(37, 42, 43);
    }

    fieldset.Fieldset legend {
        padding-inline-start: 5px;
        padding-inline-end: 8px;
    }

    .Powered {
        display: flex;
        justify-content: flex-end;
        padding-top: 8px;
        padding-right: 6px;
        font-size: 0.8rem;
    }

    .italic {
        font-style: italic;
    }
</style>


<template lang="pug">

iframe( name="hidden_iframe" id="hidden_iframe" style="display:none;" )

form( method="post" :action="definition.action" target="hidden_iframe" @submit="Submit" )
    //- @submit.prevent target="_self"
    //- h3 {{ definition.title }}

    //- Steps( :step="form.step" :steps="form.steps-1" )

    .Nav.flex
        
        
        //- button( v-if="form.step===form.steps-1" type="submit" :disabled="!form.completed" @click="Submit" ) Submit
        Button( v-if="form.step>=form.steps-1" type="submit" :disabled="form.step===form.steps" ) Absenden
        //- input( v-if="form.step===form.steps-1" class="button" type="submit" value="Submit" :disabled="!form.completed"  )

        //- button( v-else-if="!form.done" @click.prevent="Next" :disabled="!can_go" ) Next
        Button( v-else @click.prevent="Next" :disabled="!can_go" ) {{ form.step===0 ? 'Start' : 'Weiter' }}

        Button.BackButton.Light(  @click.prevent="Back" :disabled="form.step===0" ) Zurück

        Button.DevButton( v-if="definition.dev" @click.prevent="ToggleDevView" ) {{ ( definition.dev_view ? '!' : '' ) + 'Dev' }}

    //- Page( v-bind="page" :key="page.title" :index="form.step" )

    //- All Pages
    //- Page( v-for="page,i in definition.pages" :key="page.title" :index="i" :data="page" )

    //- OnePage v-show="form.step===i"
    //- Page( v-for="page,i in pages"  v-bind="page" :key="page.title" :index="i" :data="page" )

    fieldset.Fieldset

        legend
            Steps( :step="form.step" :steps="form.steps" :title="page.title" )
    
        Page( v-for="page,i in definition.pages" v-show="form.step===i" :key="page.title" :index="i-1" :data="page" )

    .Powered
        span.italic powered by&nbsp;
        span HierBeiDir

    //- input( class="button" type="submit" value="Submit" )
    //- button( class="button" type="submit" ) Submit

    input( type="hidden" name="fvv" value="1" )
    input( type="hidden" name="fbzx" value="-3038520918977173707" )
    input( type="hidden" name="pageHistory" value="0,1,2,3,4,5,6,7" )
    //- input( class="btn btn-primary" type="submit" value="Submit" )



.Dev( v-if="definition.dev_view" )
    hr
    p form.completed: {{ form.completed }}
    p form.done: {{ form.done }}
    p form.step: {{ form.step }}
    p form.steps: {{ form.steps }}
    p perc: {{ perc }}
    p step_width: {{ step_width }}

    pre
        code {{ JSON.stringify( inputs, null, 4 ) }}

//- pre
    code {{ JSON.stringify( form.data, null, 4 ) }}

</template>


<script>

import { defineComponent, ref, reactive, computed } from 'vue'

import useState from '../state'

import Steps from './Steps.vue'
import Page from './Page.vue'
import Button from './Button.vue'

export default defineComponent( {

    name: 'Form',

    components: {
        Steps, Page, Button,
    },

    // props: ['title', 'action', 'pages'],

    setup( props ) {

        // const form = reactive( {
        //     steps: props.pages.length - 1,
        //     step: 0,
        //     done: false,
        //     data: [],
        // } )

        const { definition, form, inputs, saveToStorage, crossMessage } = useState()

        const page = computed( () => definition.pages[form.step] )

        // const CanGo = () => {

        //     // if( ( typeof inputs[form.step] === 'string' && inputs[form.step] !== '' ) || ( typeof inputs[form.step] === 'object' && inputs[form.step].length > 0 ) )

        //     return ( ( typeof inputs[form.step] === 'string' && inputs[form.step] !== '' ) || ( typeof inputs[form.step] === 'object' && inputs[form.step].length > 0 ) )

        // }



        const ToggleDevView = () => {

            definition.dev_view = !definition.dev_view

        }

        const can_go = computed( () => {

            if( form.step === 0 ) return true

            const val = inputs[form.step - 1]

            return ( ( typeof val === 'string' && val !== '' ) || ( typeof val === 'object' && val.length > 0 ) )

        } )

        const Next = () => {

            // if( CanGo() )

            form.step++

            saveToStorage()

        }

        const Back = () => {

            form.step--

            saveToStorage()

        }



        const Submit = e => {

            if( definition.dev ) e.preventDefault()

            form.step = form.steps
            form.done = true
            if( definition.dev ) console.log( 'Submit' )
            // alert( 'Submit' )
            saveToStorage()

            if( definition.dev ) console.log( 'Submit > email:', inputs[inputs.length - 1] )

            crossMessage( { email: inputs[inputs.length - 1] } )

        }



        const perc = computed( () => `${ form.step === form.steps ? 0 : Math.round( form.step / form.steps * 100 ) }%` )

        const step_width = computed( () => `${ form.step === form.steps ? 100 : Math.round( 100 / form.step ) }%` )

        return {
            definition, form, page, ToggleDevView, Next, Back, Submit, inputs, can_go, perc, step_width
        }

    },

} )
</script>